import { biliBridge, initEnv, isSupport } from '@bilibili/js-bridge';
import databus from './../common/databus';
import { getScript, setChannelKey } from './../common/utils';
export default function AppContent(share, behavior) {
    var shareChannelQueue = share.shareChannelQueue, weibo = share.weibo, qzone = share.qzone, qq = share.qq, bili = share.bili, weixin = share.weixin, weixin_moment = share.weixin_moment, edit_content = share.edit_content, share_id = share.share_id, share_origin = share.share_origin, sid = share.sid, oid = share.oid, success = share.success, cancel = share.cancel, isMpc = share.isMpc, biz_type = share.biz_type, type = share.type;
    var title = bili.title, desc = bili.desc, link = bili.link, pics = bili.pics;
    var _a = databus.browser, isIpad = _a.isIpad, isPad = _a.isPad, isIos = _a.isIos, isAndroid = _a.isAndroid, biliVersion = _a.biliVersion, isBiliApp = _a.isBiliApp, hasMangaMallSdk = _a.hasMangaMallSdk, biliMangaMallSdkVersion = _a.biliMangaMallSdkVersion;
    if (!(window.biliios ||
        window.biliandroid ||
        window.biliapp ||
        isBiliApp)) {
        return;
    }
    var mpcBridgeData = share.customMpcData || parseMpcBridgeData();
    appInit();
    function appInit() {
        if (((isPad || isIpad) && biliVersion <= 5291) ||
            (isIos && biliVersion < 6670) ||
            (isAndroid && biliVersion < 5250)) {
            if (hasMangaMallSdk && biliMangaMallSdkVersion >= 300) {
                newBiliReady();
            }
            else {
                oldBiliReady();
            }
        }
        else {
            newBiliReady();
        }
    }
    function newBiliReady() {
        initEnv();
        behavior === 'show' ? newBiliShow() : newBiliSet();
    }
    function onShare(shareResp) {
        console.log('onShare: ', shareResp);
        if (shareResp.state == 0) {
            success(shareResp);
        }
        else {
            cancel(shareResp);
        }
    }
    function newBiliShow() {
        if (!isMpc ||
            (isIos && biliVersion < 8270) ||
            (isAndroid && biliVersion < 5300)) {
            newSupport('share.showShareWindow', function () {
                biliBridge.callNative({
                    method: 'share.showShareWindow',
                    data: {
                        title: title,
                        type: type,
                        text: desc,
                        url: link,
                        image_url: pics
                    },
                    callback: function () {
                        console.log('share.showShareWindow 成功弹出分享窗口');
                    },
                    onShare: onShare
                });
            });
        }
        else {
            newSupport('share.showShareMpcWindow', function () {
                biliBridge.callNative({
                    method: 'share.showShareMpcWindow',
                    data: mpcBridgeData,
                    callback: function () {
                        console.log('share.showShareMpcWindow 成功弹出分享窗口');
                    },
                    onShare: onShare
                });
            });
        }
    }
    function newBiliSet() {
        if (!isMpc ||
            (isIos && biliVersion < 8270) ||
            (isAndroid && biliVersion < 5300)) {
            newSupport('share.setShareContent', function () {
                biliBridge.callNative({
                    method: 'share.setShareContent',
                    data: {
                        title: title,
                        type: type,
                        text: desc,
                        url: link,
                        image_url: pics
                    },
                    callback: function () {
                        console.log('share.setShareContent 成功设置分享');
                    },
                    onShare: onShare
                });
            });
        }
        else {
            newSupport('share.setShareMpcContent', function () {
                biliBridge.callNative({
                    'method': 'share.setShareMpcContent',
                    data: mpcBridgeData,
                    callback: function () {
                        console.log('share.setShareMpcContent 成功设置分享');
                    },
                    onShare: onShare
                });
            });
        }
    }
    function parseMpcBridgeData() {
        return {
            share_id: share_id,
            share_origin: share_origin,
            sid: sid,
            oid: oid,
            shareChannelQueue: shareChannelQueue,
            'dynamic': {
                title: bili.title,
                content_id: 0,
                content_type: isIos ? 2048 : 12,
                cover_url: bili.pics,
                description: bili.desc,
                publish: false,
                edit_content: bili.text_area || edit_content,
                sketch: {
                    title: bili.title,
                    biz_type: biz_type || 3,
                    cover_url: bili.pics,
                    target_url: setChannelKey(bili.link, 'bili'),
                    desc_text: bili.desc
                }
            },
            'weixin': {
                type: weixin.type || type,
                title: weixin.title,
                text: weixin.desc,
                url: setChannelKey(weixin.link, 'weixin'),
                imageUrl: weixin.pics,
                media_src: weixin.media_src
            },
            'weixin_monment': {
                type: weixin_moment.type || type,
                title: weixin_moment.title,
                text: weixin_moment.desc,
                url: setChannelKey(weixin_moment.link, 'weixin_moment'),
                imageUrl: weixin_moment.pics,
                media_src: weixin_moment.media_src
            },
            'qq': {
                type: qq.type || type,
                title: qq.title,
                text: qq.desc,
                url: setChannelKey(qq.link, 'qq'),
                imageUrl: qq.pics,
                media_src: qq.media_src
            },
            'q_zone': {
                type: qzone.type || type,
                title: qzone.title,
                text: qzone.desc,
                url: setChannelKey(qzone.link, 'qzone'),
                imageUrl: qzone.pics,
                media_src: qzone.media_src
            },
            'sina': {
                type: weibo.type || type,
                title: weibo.title,
                text: weibo.desc,
                url: setChannelKey(weibo.link, 'weibo'),
                imageUrl: weibo.pics,
                media_src: weibo.media_src
            },
            'default': {
                type: type,
                title: title,
                text: desc,
                url: setChannelKey(link, ''),
                imageUrl: pics,
            }
        };
    }
    function newSupport(funcName, callback) {
        isSupport(funcName).then(function (support) {
            if (support) {
                callback && callback();
            }
            else {
                window.console.log("not support " + funcName);
            }
        });
    }
    function oldBiliReady() {
        var biliShare = {
            title: title,
            biz_type: biz_type,
            text: desc,
            url: link,
            image_url: pics
        };
        if (behavior === 'show') {
            biliJsBridge(function () {
                window.BiliApp.showShareWindow(biliShare);
            });
        }
        else {
            biliJsBridge(function () {
                window.BiliApp.setShareContent(biliShare);
            });
        }
        function biliJsBridge(callback) {
            if (!window.BiliApp) {
                getScript('https://static.hdslb.com/biliapp/biliapp.js', function () {
                    callback && callback();
                });
            }
            else {
                callback && callback();
            }
        }
    }
}
